
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchSwapRequestById } from "@/services/swapRequests";
import SwapRequestLayout from "@/components/swap/SwapRequestLayout";
import SwapRequestDetails from "@/components/swap/SwapRequestDetails";
import SwapRequestNotFound from "@/components/swap/SwapRequestNotFound";

const ViewSwapRequestPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  const { data: swapRequest, isLoading, error } = useQuery({
    queryKey: ['swapRequest', id],
    queryFn: () => fetchSwapRequestById(id!),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <SwapRequestLayout isLoading={true}>
        <div>Loading swap request details...</div>
      </SwapRequestLayout>
    );
  }

  if (error || !swapRequest) {
    return <SwapRequestNotFound />;
  }

  return (
    <SwapRequestLayout reagentId={swapRequest.reagent_id}>
      <SwapRequestDetails swapRequest={swapRequest} />
    </SwapRequestLayout>
  );
};

export default ViewSwapRequestPage;
